export interface Props {
  iconPath: string;
  viewBoxWidth: number;
  viewBoxHeight: number;
  width?: number;
  height?: number;
  mainClass?: string;
  standardAtom?: boolean;
  onClick?: () => any;
}

const Svg = ({ height, mainClass, iconPath, standardAtom, viewBoxHeight, viewBoxWidth, width, onClick }: Props) => {
  const classes: string[] = [];
  if (mainClass) {
    classes.push(mainClass);
  }
  if (standardAtom) {
    classes.push('fm-a-svg');
  }
  const className = classes.join(' ');
  const href = iconPath.startsWith('#') ? '/assets/images/new-icons.svg' + iconPath : iconPath;

  return (
    <svg
      onClick={onClick}
      className={className}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={width || viewBoxWidth}
      height={height || viewBoxHeight}
      aria-hidden="true"
    >
      <use xlinkHref={href}></use>
    </svg>
  );
};

export default Svg;
